import { get } from 'lodash';
import { connect } from 'react-redux';
import { List, ListItem, ListItemText, Collapse } from '@material-ui/core';
import { Add, Remove } from '@material-ui/icons';
import { seViewSoothePassFAQ } from '../Shared/WebAnalytics';
import { useState, useEffect } from 'react';
import { getSoothePassFAQ } from '../Shared/Helpers';

const FAQ = (props) => {
    const [openedIndex, setOpenedIndex] = useState(null);
    const [faq, setFaq] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {   
        const client_id = get(props, 'client.user_id');
        const subscription_tier_id = get(props, 'client.soothe_pass.subscription_tier_id');
        
        if (client_id && subscription_tier_id) {
            getSoothePassFAQ(
                client_id,
                subscription_tier_id,
                (response) => {
                    const faqData = get(response, 'data.faq', []);
                    
                    // If no FAQ data from API, fallback to client object
                    if (!faqData || faqData.length === 0) {
                        const fallbackFaq = get(props, 'client.soothe_pass.faq', []);
                        setFaq(fallbackFaq);
                    } else {
                        setFaq(faqData);
                    }
                    setIsLoading(false);
                },
                (error) => {
                    console.log('error', error);
                    // On API error, fallback to client object
                    const fallbackFaq = get(props, 'client.soothe_pass.faq', []);
                    setFaq(fallbackFaq);
                    setIsLoading(false);
                }
            );
        } else {
            // If no client_id or subscription_tier_id, try fallback
            const fallbackFaq = get(props, 'client.soothe_pass.faq', []);
            setFaq(fallbackFaq);
            setIsLoading(false);
        }
    }, [props.client]);

    if (isLoading) {
        return (
            <div>
                <div className='size-24-32 contentPrimary font-weight-bold mb-16'>FAQs</div>
                <div className='size-16-20 contentSecondary'>Loading FAQs...</div>
            </div>
        );
    }

    if (!faq || faq.length === 0) {
        return (
            <div>
                <div className='size-24-32 contentPrimary font-weight-bold mb-16'>FAQs</div>
                <div className='size-16-20 contentSecondary'>No FAQs available at the moment.</div>
            </div>
        );
    }

    return (<div style={{
        padding: '16px'
    }}>
        <div className='size-24-32 contentPrimary font-weight-bold mb-16'>FAQs</div>
        <List component="nav" aria-labelledby="nested-list-subheader">
            {faq.map((doc, ind) => (
                <div key={ind}>
                    <ListItem className='size-16-20 pl-0-imp'
                        button
                        key={`question-${ind}`}
                        onClick={() => {
                            if (openedIndex === ind) {
                                setOpenedIndex(-1);
                            } else {
                                if (openedIndex === null) {
                                    const subscription_tier_id = get(props, 'client.soothe_pass.subscription_tier_id', null);
                                    const subscription_tier_name = get(props, 'client.soothe_pass.subscription_tier_name', null);
                                    seViewSoothePassFAQ(subscription_tier_name, subscription_tier_id);
                                }
                                setOpenedIndex(ind);
                            }
                        }}
                    >
                        <ListItemText primary={doc.question} />
                        {openedIndex === ind ? <Remove /> : <Add />}
                    </ListItem>
                    <Collapse
                        key={`collapse-${ind}`}
                        in={openedIndex === ind}
                        timeout="auto"
                        unmountOnExit
                    >
                        <div className='pl-24 size-14-20 contentSecondary'>{doc.answer}</div>
                    </Collapse>
                </div>
            ))}
        </List>
    </div>)
}
const mapStateToProps = (state) => ({
    client: state.client,
});

export default connect(mapStateToProps)(FAQ); 